import { ILoginAction, ILoginState } from './login.types'
import { LoginConstants } from './login.constants'

export const initialLoginState: ILoginState = {
  loginFailed: false,
  authenticationJwt: null,
  loginPhaseIsLoading: false,
  userVerifyErrorText: '',
  loginCallbackUrl: '',
}

export function loginReducer(state: ILoginState = initialLoginState, action: ILoginAction): ILoginState {
  switch (action.type) {
    case LoginConstants.RESET_LOGIN:
      return { ...initialLoginState }
    case LoginConstants.SET_LOGIN_FAILED:
      return { ...state, loginFailed: action.loginFailed }
    case LoginConstants.SET_AUTHENTICATION_JWT:
      return { ...state, authenticationJwt: action.authenticationJwt }
    case LoginConstants.SET_LOGIN_PHASE_IS_LOADING:
      return { ...state, loginPhaseIsLoading: action.loginPhaseIsLoading }
    case LoginConstants.SET_USER_VERIFY_ERROR_TEXT:
      return { ...state, userVerifyErrorText: action.userVerifyErrorText }
    case LoginConstants.SET_LOGIN_CALLBACK_URL:
      return { ...state, loginCallbackUrl: action.loginCallbackUrl }
    default:
      return state
  }
}
